import { render, staticRenderFns } from "./Variationdetails.vue?vue&type=template&id=6a522fcb&scoped=true"
import script from "./Variationdetails.vue?vue&type=script&lang=js"
export * from "./Variationdetails.vue?vue&type=script&lang=js"
import style0 from "./Variationdetails.vue?vue&type=style&index=0&id=6a522fcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a522fcb",
  null
  
)

export default component.exports